import React from 'react';
import styled from 'styled-components';
import { COLOR_SYSTEM, Text } from 'components/atoms';

interface ExperimentStepIndicatorProps {
  currentStep: number;
  totalSteps: number;
}

const steps = [
  '기본 정보',
  '실행 모드',
  'AI Review 설정',
  '평가 설정',
  'ID 선택',
  '추가 옵션',
  '확인 및 실행'
];

const ExperimentStepIndicator: React.FC<ExperimentStepIndicatorProps> = ({
  currentStep,
  totalSteps,
}) => {
  return (
    <Container>
      {steps.slice(0, totalSteps).map((step, index) => {
        const stepNumber = index + 1;
        const isActive = stepNumber === currentStep;
        const isCompleted = stepNumber < currentStep;
        
        return (
          <React.Fragment key={stepNumber}>
            <StepItem>
              <StepCircle $isActive={isActive} $isCompleted={isCompleted}>
                {isCompleted ? '✓' : stepNumber}
              </StepCircle>
              <StepLabel $isActive={isActive} $isCompleted={isCompleted}>
                {step}
              </StepLabel>
            </StepItem>
            {stepNumber < totalSteps && (
              <StepConnector $isCompleted={isCompleted} />
            )}
          </React.Fragment>
        );
      })}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 0;
`;

const StepItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;

const StepCircle = styled.div<{ $isActive: boolean; $isCompleted: boolean }>`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.2s ease;
  
  ${({ $isActive, $isCompleted }) => {
    if ($isCompleted) {
      return `
        background-color: ${COLOR_SYSTEM.get("Blue")?.[500]};
        color: white;
        border: 2px solid ${COLOR_SYSTEM.get("Blue")?.[500]};
      `;
    }
    if ($isActive) {
      return `
        background-color: white;
        color: ${COLOR_SYSTEM.get("Blue")?.[500]};
        border: 2px solid ${COLOR_SYSTEM.get("Blue")?.[500]};
      `;
    }
    return `
      background-color: white;
      color: ${COLOR_SYSTEM.get("Gray")?.[400]};
      border: 2px solid ${COLOR_SYSTEM.get("Gray")?.[300]};
    `;
  }}
`;

const StepLabel = styled(Text)<{ $isActive: boolean; $isCompleted: boolean }>`
  font-size: 12px;
  white-space: nowrap;
  color: ${({ $isActive, $isCompleted }) => 
    $isActive || $isCompleted 
      ? COLOR_SYSTEM.get("Gray")?.[900] 
      : COLOR_SYSTEM.get("Gray")?.[500]
  };
  font-weight: ${({ $isActive }) => $isActive ? 600 : 400};
`;

const StepConnector = styled.div<{ $isCompleted: boolean }>`
  width: 60px;
  height: 2px;
  background-color: ${({ $isCompleted }) => 
    $isCompleted 
      ? COLOR_SYSTEM.get("Blue")?.[500] 
      : COLOR_SYSTEM.get("Gray")?.[300]
  };
  margin: 0 8px;
  margin-bottom: 24px;
`;

export default ExperimentStepIndicator;